export default __webpack_public_path__ + "static/media/bg-mobile.0e017b69.jpg";